export function shouldShowMentionBadge(chat: {
  hasUnreadMention?: boolean;
  isNewModelChannel?: boolean;
  isChatAccessible?: boolean;
}): boolean {
  if (chat.isNewModelChannel === true && chat.isChatAccessible === false) return false;
  return chat.hasUnreadMention === true;
}

export function applyMentionFlagsToRows<T extends { channelUrl: string; hasUnreadMention?: boolean }>(
  rows: T[],
  mentionFlagsByUrl: Record<string, boolean>,
): T[] {
  return rows.map((row) => ({
    ...row,
    hasUnreadMention: row.channelUrl ? mentionFlagsByUrl[row.channelUrl] ?? false : false,
  }));
}

export function applyMentionFlagsToChatsRecord<
  T extends { channelUrl: string; hasUnreadMention?: boolean },
  E extends { chats: T[] },
>(events: E[], mentionFlagsByUrl: Record<string, boolean>): E[] {
  return events.map((event) => ({
    ...event,
    chats: applyMentionFlagsToRows(event.chats, mentionFlagsByUrl),
  }));
}
